import styles from '../styles/stepcard.module.scss';

import { Card } from '@aws-amplify/ui-react';

const StepCard = ({ TextColor, ButtonColor, index, description, TitleText, Icon, fontFamily }: PropTypes) => {
  return (
    <div className={styles.step}>
      <Card className={styles.card} style={{ borderTopColor: TextColor }} variation="elevated">
        <div className={styles.card_content}>
          <div className={styles.card_item}>
            <Icon className={styles.card_image} color={ButtonColor} />
            <h2 className={styles.card_item_heading} style={{ fontFamily: fontFamily }}>
              {TitleText}
            </h2>
          </div>
          <div className={styles.card_item_description}>
            <p>
              <span style={{ color: TextColor }}>
                <b>{index}. </b>
              </span>
              {description}
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
};

interface PropTypes {
  TextColor: string;
  ButtonColor: string;
  Icon: Function;
  index: number;
  description: string;
  TitleText: string;
  fontFamily?: string;
}

export default StepCard;
